import React, { useState, useEffect } from 'react'
import queryString from 'query-string';

import '../style.css'

export default function FilterList({ history }) {
  const [status, setStatus] = useState(false);
  const [patient, setPatient] = useState(false)
  const [participant, setParticipant] = useState(false)
  const [location, setLocation] = useState(false)

  useEffect(() => {
    const queryParams = queryString.parse(history.location.search);

    setStatus(queryParams.status || '')

    if (queryParams.userId) {
      setParticipant({ value: queryParams.userId, label: queryParams.user})
    } else {
      setParticipant(false)
    }

    if (queryParams.patientId) {
      setPatient({ value: queryParams.patientId, label: queryParams.patient})
    } else {
      setPatient(false)
    }

    if (queryParams.locationId) {
      setLocation({ value: queryParams.locationId, label: queryParams.location })
    } else {
      setLocation(false)
    }

  }, [history.location.search])

  if (!status && !patient && !participant && !location) {
    return null
  }

  return (
    <div className='row'>
      <div className='col-auto my-auto py-2'>
        <h5 className='m-0'>Filters:</h5>
      </div>

      <div className='col-auto pl-0'>
        {patient &&
          <span
            style={{ fontSize: '14px', borderRadius: '1.5em' }}
            className='m-1 badge badge-info py-2 pl-3 filter__item'
            onClick={() => {
              const urlParams = queryString.parse(history.location.search);

              urlParams.page = 1
              urlParams.patient = ''
              urlParams.patientId = ''

              history.push(`/messages?${queryString.stringify(urlParams)}`)
            }}
          >
            {patient.label} <span className='font-weight-light pl-2'> | </span> <span className='filter__item__close'>x</span> &nbsp;
          </span>
        }

        {participant &&
          <span
            style={{ fontSize: '14px', borderRadius: '1.5em' }}
            className='m-1 badge badge-info py-2 pl-3 filter__item'
            onClick={() => {
              const urlParams = queryString.parse(history.location.search);

              urlParams.page = 1
              urlParams.user = ''
              urlParams.userId = ''

              history.push(`/messages?${queryString.stringify(urlParams)}`)
            }}
          >
            {participant.label} <span className='font-weight-light pl-2'> | </span> <span className='filter__item__close'>x</span> &nbsp;
          </span>
        }

        {location &&
          <span
            style={{ fontSize: '14px', borderRadius: '1.5em' }}
            className='m-1 badge badge-info py-2 pl-3 filter__item'
            onClick={() => {
              const urlParams = queryString.parse(history.location.search);

              urlParams.page = 1
              urlParams.location = ''
              urlParams.locationId = ''

              history.push(`/messages?${queryString.stringify(urlParams)}`)
            }}
          >
            {location.label} <span className='font-weight-light pl-2'> | </span> <span className='filter__item__close'>x</span> &nbsp;
          </span>
        }

        {status &&
          <span style={{ fontSize: '14px', borderRadius: '1.5em' }}
            className='m-1 badge badge-info py-2 pl-3 filter__item'
            onClick={() => {
              const urlParams = queryString.parse(history.location.search);

              urlParams.page = 1
              urlParams.status = ''

              history.push(`/messages?${queryString.stringify(urlParams)}`)
            }}
          >
            <span className='text-capitalize'>{status}</span><span className='font-weight-light pl-2'> | </span> <span className='filter__item__close'>x</span> &nbsp;
          </span>
        }
      </div>
    </div>
  )
}
